import React, { Component } from 'react';
import { CircularProgress, DialogActions, Button, TextField, DialogContent, DialogTitle, Dialog, MenuItem, FormControl, InputLabel, Select, Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import demandService from '../../api/demandsService';
import { cleanDemand } from '../../redux/actions/demandActions';
import { distinct } from '../../shared/helpers/distinctArray';
import { getSelectOptions } from '../../shared/helpers/selectHelper';
import PhoneNumberField from '../../shared/components/PhoneNumberField';
import { getAllCities } from '../../api/cityService';
import './DemandForm.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { NumberFormat } from 'react-number-format';

const estadosEUA = [
    { nome: "Alabama", sigla: "AL" },
    { nome: "Alaska", sigla: "AK" },
    { nome: "Arizona", sigla: "AZ" },
    { nome: "Arkansas", sigla: "AR" },
    { nome: "California", sigla: "CA" },
    { nome: "Colorado", sigla: "CO" },
    { nome: "Connecticut", sigla: "CT" },
    { nome: "Delaware", sigla: "DE" },
    { nome: "Florida", sigla: "FL" },
    { nome: "Georgia", sigla: "GA" },
    { nome: "Hawaii", sigla: "HI" },
    { nome: "Idaho", sigla: "ID" },
    { nome: "Illinois", sigla: "IL" },
    { nome: "Indiana", sigla: "IN" },
    { nome: "Iowa", sigla: "IA" },
    { nome: "Kansas", sigla: "KS" },
    { nome: "Kentucky", sigla: "KY" },
    { nome: "Louisiana", sigla: "LA" },
    { nome: "Maine", sigla: "ME" },
    { nome: "Maryland", sigla: "MD" },
    { nome: "Massachusetts", sigla: "MA" },
    { nome: "Michigan", sigla: "MI" },
    { nome: "Minnesota", sigla: "MN" },
    { nome: "Mississippi", sigla: "MS" },
    { nome: "Missouri", sigla: "MO" },
    { nome: "Montana", sigla: "MT" },
    { nome: "Nebraska", sigla: "NE" },
    { nome: "Nevada", sigla: "NV" },
    { nome: "New Hampshire", sigla: "NH" },
    { nome: "New Jersey", sigla: "NJ" },
    { nome: "New Mexico", sigla: "NM" },
    { nome: "New York", sigla: "NY" },
    { nome: "North Carolina", sigla: "NC" },
    { nome: "North Dakota", sigla: "ND" },
    { nome: "Ohio", sigla: "OH" },
    { nome: "Oklahoma", sigla: "OK" },
    { nome: "Oregon", sigla: "OR" },
    { nome: "Pennsylvania", sigla: "PA" },
    { nome: "Rhode Island", sigla: "RI" },
    { nome: "South Carolina", sigla: "SC" },
    { nome: "South Dakota", sigla: "SD" },
    { nome: "Tennessee", sigla: "TN" },
    { nome: "Texas", sigla: "TX" },
    { nome: "Utah", sigla: "UT" },
    { nome: "Vermont", sigla: "VT" },
    { nome: "Virginia", sigla: "VA" },
    { nome: "Washington State", sigla: "WA" },
    { nome: "West Virginia ", sigla: "WV" },
    { nome: "Wisconsin ", sigla: "WI" },
    { nome: "Wyoming ", sigla: "WY" }
];

class DemandForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requiredFieldsError: '',
            cities: [], // Adicione a declaração do estado cities e inicialize como um array vazio
            showOverlay: false,
            loading: false,
            loadingCities: false,
            id: null,
            customerName: '',
            email: '',
            customerContact: '',
            category: '',
            subcategory: '',
            description: '',
            isFullTime: false,
            requirements: [],
            zipCode: '',
            city: '',
            stateCode: '',
            price: '',
            displayPrice: '', // Adicione um novo estado para o valor de exibição do preço
            priceError: '', // Adicione um novo estado para a mensagem de erro do preço
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.changePhoneNumber = this.changePhoneNumber.bind(this);
        this.changeCity = this.changeCity.bind(this);
        this.changeStateCode = this.changeStateCode.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.changeFullName = this.changeFullName.bind(this);

        this.changeSelectedCategory = this.changeSelectedCategory.bind(this);
        this.changeSelectedSubcategory = this.changeSelectedSubcategory.bind(this);

        this.changeDescription = this.changeDescription.bind(this);
        this.changeIsFullTime = this.changeIsFullTime.bind(this);
        this.changeRequirements = this.changeRequirements.bind(this);
        this.changeZipCode = this.changeZipCode.bind(this);
        this.changePrice = this.changePrice.bind(this);

        this.addDemand = this.addDemand.bind(this);
    }

    setDemandDetails() {
        if (this.props.selectedDemand) {
            const { id,
                customerName,
                email,
                customerContact,
                category,
                subcategory,
                description,
                isFullTime,
                requirements,
                zipCode,
                city,
                stateCode,
                price } = this.props.selectedDemand;
            this.setState({
                id,
                customerName,
                email,
                customerContact,
                category,
                subcategory,
                description,
                isFullTime,
                requirements,
                zipCode,
                city,
                stateCode,
                price
            });
        } else {
            this.setState({
                id: null,
                customerName: '',
                email: '',
                customerContact: '',
                category: '',
                subcategory: '',
                description: '',
                isFullTime: false,
                requirements: [],
                zipCode: '',
                city: '',
                stateCode: '',
                price: ''
            });
        }
    }

    closeModal() {
        this.props.cleanDemand();
        this.props.hideForm();
    }

    changeFullName(evt) {
        this.setState({
            customerName: evt.target.value
        });
    }

    changePhoneNumber(evt) {
        this.setState({
            customerContact: evt.target.value
        });
    }

    changeEmail(evt) {
        this.setState({
            email: evt.target.value
        });
    }

    changeResponsibleName(evt) {
        this.setState({
            responsibleName: evt.target.value
        });
    }
    changeCity(evt, newValue) {
        this.setState({
            city: newValue ? newValue.name : '', // Use o nome da cidade se um valor válido for selecionado
        });
    }

    async changeStateCode(evt) {
        const newStateCode = evt.target.value;

        // Defina o estado com o novo código de estado.
        this.setState({
            stateCode: newStateCode,
            city: '', // Limpa o campo da cidade
            cities: [], // Limpa a lista de cidades
            loadingCities: true,
        });

        if (newStateCode) {
            try {
                // Obtenha a lista de cidades com base no código do estado.
                const cities = await getAllCities(newStateCode);

                // Atualize o estado com as cidades correspondentes.
                this.setState({ cities });
            } catch (error) {
                // Lide com erros, se necessário
            } finally {
                this.setState({ loadingCities: false }); // Define loadingCities como false após o carregamento
            }
        }
    }

    changeSelectedCategory(evt) {
        this.setState({
            category: evt.target.value
        });
    }

    changeSelectedSubcategory(evt) {
        this.setState({
            subcategory: evt.target.value
        });
    }

    changeDescription(evt) {
        this.setState({
            description: evt.target.value
        });
    }

    changeIsFullTime(evt) {
        this.setState({
            isFullTime: evt.target.checked
        });
    }

    changeRequirements(evt) {
        const inputRequirements = evt.target.value.split(',');
        this.setState({
            requirements: inputRequirements
        });
    }

    changeZipCode(evt) {
        this.setState({
            zipCode: evt.target.value
        });
    }

    changePrice = (evt) => {
        // Remove qualquer formatação do valor
        const price = evt.target.value.replace(/\D/g, '');

        // Formata o preço como dólar
        let displayPrice;
        if (Number(price) % 1 === 0) { // Se o número for um inteiro
            displayPrice = `$${Number(price).toLocaleString()}`;
        } else { // Se o número tiver casas decimais
            displayPrice = `$${Number(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
        }

        this.setState({ price, displayPrice, priceError: '' });
    }

    addDemand() {
        const { customerName,
            email,
            customerContact,
            category,
            subcategory,
            description,
            isFullTime,
            requirements,
            zipCode,
            city,
            stateCode,
            price } = this.state;

        // Verifique se todos os campos obrigatórios estão preenchidos
        if (
            !customerName ||
            !email ||
            !customerContact ||
            !category ||
            !subcategory ||
            !description ||
            !zipCode ||
            !city ||
            !stateCode ||
            !price
        ) {
            // Campos obrigatórios em falta, mostre uma mensagem de alerta ou manipule a validação aqui.
            this.setState({ requiredFieldsError: 'Please fill in all required fields.' });
            return;
        }

        this.setState({ showOverlay: true });
        this.setState({ loading: true });

        demandService.createDemandAndAccount(customerName,
            email,
            customerContact,
            category,
            subcategory,
            description,
            isFullTime,
            requirements,
            zipCode,
            city,
            stateCode,
            parseInt(price, 10))
            .then(() => {
                this.closeModal();
            })
            .catch((error) => {
                // Lida com erros, se necessário
            })
            .finally(() => {
                this.setState({ loading: false }); // Defina loading como false após a conclusão
                this.setState({ showOverlay: false });
            });
    }

    updateDemand() {
        const { customerName,
            email,
            customerContact,
            category,
            subcategory,
            description,
            isFullTime,
            requirements,
            zipCode,
            city,
            stateCode,
            price } = this.state;
        demandService.createDemandAndAccount(customerName,
            email,
            customerContact,
            category,
            subcategory,
            description,
            isFullTime,
            requirements,
            zipCode,
            city,
            stateCode,
            price)
            .then(() => {
                this.closeModal();
            });
    }

    render() {
        const { showModal, categories, loading } = this.props;
        const { id, customerName,
            email,
            customerContact,
            category,
            subcategory,
            description,
            isFullTime,
            requirements,
            zipCode,
            city,
            stateCode,
            price } = this.state;
        const isEditing = Boolean(id);

        const showSubcategory = this.state.category !== '';

        const subcategoriesFiltered = showSubcategory ?
            categories.filter((cat) => cat.name === category)[0].subcategories.map((subcat) => ({ value: subcat.description, display: subcat.description }))
            :
            [{ value: '', display: 'Select a Category.' }];

        return (
            <Dialog onRendered={() => {
                this.setDemandDetails();
            }} open={showModal} onClose={this.closeModal} aria-labelledby="form-dialog-title">
                {this.state.showOverlay && (
                    <div className="overlay" style={{ zIndex: 1, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)' }}>
                        <CircularProgress className="loading-spinner" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                    </div>
                )}
                <DialogTitle id="form-dialog-title">{isEditing ? `Editing ${customerName}'s details` : "Add a new Demand"}</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="Customer Name"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeFullName}
                        value={customerName}
                        fullWidth
                        required
                    />

                    <TextField
                        margin="normal"
                        id="email"
                        variant="outlined"
                        label="Customer Email"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeEmail}
                        value={email}
                        fullWidth
                        required
                    />

                    <TextField
                        margin="normal"
                        id="phoneNumber"
                        variant="outlined"
                        label="Customer Phone Number"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        InputProps={{ inputComponent: PhoneNumberField }}
                        onChange={this.changePhoneNumber}
                        value={customerContact}
                        fullWidth
                        required
                    />

                    <TextField
                        margin="normal"
                        id="zipCode"
                        variant="outlined"
                        label="Zip code"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeZipCode}
                        value={zipCode}
                        fullWidth
                        required
                    />

                    <FormControl
                        variant="outlined" fullWidth margin="normal">
                        <InputLabel id="stateCode-label">State code</InputLabel>
                        <Select
                            labelId="stateCode-label"
                            id="stateCode"
                            value={stateCode}
                            onChange={this.changeStateCode}
                            label="State code"
                            required
                        >
                            {estadosEUA.map((estado) => (
                                <MenuItem key={estado.sigla} value={estado.sigla}>
                                    {estado.nome}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Autocomplete
                        options={this.state.cities}
                        getOptionLabel={(option) => option.name}
                        value={this.state.cities.find(city => city.name === this.state.city) || null} // Use find para encontrar o objeto da cidade com base no nome
                        onChange={this.changeCity} // Use a função atualizada
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="City"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                required
                            />
                        )}
                    />
                    {this.state.loadingCities && (
                        <CircularProgress className="loading-spinner" />
                    )}

                    <TextField
                        select
                        margin="normal"
                        name="category"
                        variant="outlined"
                        label="Category"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        onChange={this.changeSelectedCategory}
                        value={category}
                        fullWidth
                        required
                    >
                        {getSelectOptions(categories.map((cat) => ({ value: cat.name, display: cat.name })))}
                    </TextField>

                    <TextField
                        select
                        margin="normal"
                        name="subcategory"
                        variant="outlined"
                        label="Subcategory"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        onChange={this.changeSelectedSubcategory}
                        value={subcategory}
                        fullWidth
                        required
                    >
                        {getSelectOptions(subcategoriesFiltered)}
                    </TextField>

                    <TextField
                        margin="normal"
                        id="description"
                        variant="outlined"
                        label="Description"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeDescription}
                        value={description}
                        fullWidth
                        required
                    />

                    <TextField
                        margin="normal"
                        id="requirements"
                        variant="outlined"
                        label="Requirements"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeRequirements}
                        value={requirements}
                        fullWidth
                        required
                    />

                    <TextField
                        margin="normal"
                        id="price"
                        variant="outlined"
                        label="Price"
                        InputLabelProps={{ shrink: true }}
                        type="text" // Mude para text para permitir a formatação
                        onChange={this.changePrice}
                        value={this.state.displayPrice} // Use displayPrice para o valor
                        fullWidth
                        required
                    />
                    {this.state.priceError && <p>{this.state.priceError}</p>} {/* Mostra a mensagem de erro se houver */}

                    <TextField
                        margin="normal"
                        id="full-time-select"
                        select
                        label="Full time"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        onChange={this.changeIsFullTime}
                        value={isFullTime}
                        fullWidth
                        required
                    >
                        <MenuItem value={false}>No</MenuItem>
                        <MenuItem value={true}>Yes</MenuItem>
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeModal} color="primary">Back</Button>
                    <Button onClick={isEditing ? this.updateCompany : this.addDemand} color="primary">
                        {isEditing ? "Save" : "Add"}
                    </Button>
                </DialogActions>
                {loading && !this.state.showOverlay && <CircularProgress className="loading-spinner" />}
                {this.state.requiredFieldsError && (
                    <div className="error-message">{this.state.requiredFieldsError}</div>
                )}
            </Dialog>
        );
    }
}

const mapStateToProps = ({ demandState, locationState, categoryState }) => ({
    categories: categoryState.categories,
    selectedDemand: demandState.selectedDemand,
    states: distinct(locationState.localizations.map((city) => ({ value: city.state.stateCode, display: city.state.state })), "value")
        .sort((a, b) => {
            if (a.display < b.display)
                return -1;
            if (a.display > b.display)
                return 1;
            return 0;
        })
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanDemand }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(DemandForm);